import { getPlatforms } from '@/api/apiMain';
import { useQuery } from '@tanstack/vue-query';

export default function usePlatforms() {
  const query = useQuery({
    queryKey: ['platforms'],
    queryFn: getPlatforms,
    staleTime: 1000 * 60 * 30,
  });

  const getPlatformById = (platformId: string) => {
    return query.data?.value?.find((p) => p.id === platformId);
  };

  return { ...query, getPlatformById };
}
